import React, { useEffect, useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { auth } from "./firebase";
import { useTheme } from "./contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./components/LanguageSwitcher"; 

function MenuBar() {
  const [user, setUser] = useState(null);
  const { theme } = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <Navbar
      bg={theme === 'dark' ? 'dark' : 'light'}
      variant={theme === 'dark' ? 'dark' : 'light'}
      expand="lg"
      style={{ paddingLeft: "20px", paddingRight: "20px" }}
    >
      <Navbar.Brand href="#home">{t('app.brand')}</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <LinkContainer to="/">
            <Nav.Link>{t('navigation.home')}</Nav.Link>   
          </LinkContainer>
          <LinkContainer to="/blog">
            <Nav.Link>{t('navigation.articles')}</Nav.Link>
          </LinkContainer>
          {/* {user && (
            <>
              <LinkContainer to="/subscription">
                <Nav.Link>{t('navigation.subscription')}</Nav.Link>
              </LinkContainer>
            </>
          )} */}
        </Nav>
        <Nav className="ms-auto">
          {user ? (
            <>
              <Nav.Link href="#logout" onClick={() => auth.signOut()}>
                {t('navigation.logout')}
              </Nav.Link>
            </>
          ) : (
            <>
              <LinkContainer to="/login">
                <Nav.Link>{t('navigation.login')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/signup">
                <Nav.Link>{t('navigation.signup')}</Nav.Link>
              </LinkContainer>
            </>
          )}
          <LanguageSwitcher />
          <LinkContainer to="/terms">
            <Nav.Link className="text-muted small">{t('navigation.terms')}</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/privacy">
            <Nav.Link className="text-muted small">{t('navigation.privacy')}</Nav.Link>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default MenuBar;
